import axios from "axios";
import { create_apppointment, get_apppointment_list, update_appointment_url } from "../apiConfig";
import { getToken, getPatientInfo } from "../../localstorage";

// save nric into db for encoremed appointment list
export const save_appointment = async (nric, tenantcode, hospital_id) => {
  const postData = {
    nric: nric,
    patientId: getPatientInfo().id,
    tenantcode: tenantcode,
    hospital_id: hospital_id,
  };
  try {
    const response = await axios.post(create_apppointment, postData, {
      headers: {
        "Content-Type": "application/json",
        "X-API-KEY": "kpjhealth",
        Authorization: `Bearer ${getToken()}`,
      },
    });
    
    return response.data;
  } catch (error) {
    throw error;
  }
};

// v2, 22/10/2024, save EM appt ID too
export const update_appointment = async (data) => {
  const postData = {
    ...data,
    patientId: getPatientInfo().id
  }
  try {
    const response = await axios.post(update_appointment_url, postData, {
      headers: {
        "Content-Type": "application/json",
        "X-API-KEY": "kpjhealth",
        Authorization: `Bearer ${getToken()}`,
      },
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};

// get nric list from db for encoremed appointment list
export const get_appointment_list = async () => {
  try {
    const response = await axios.get(get_apppointment_list, {
      headers: {
        "X-API-KEY": "kpjhealth",
        Authorization: `Bearer ${getToken()}`,
      },
      params: {
        patient_id: getPatientInfo().id,
      },
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};
